// extracted by mini-css-extract-plugin
export default {"wrapper":"Create_wrapper__HUlcQ"};